import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { acGetDistributorUser } from '../../store/ducks/distributorUser/actions';

export default function useGetDistributorUser() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  async function execute(distributorId?: string, distributorUserId?: string) {
    try {
      setLoading(true);
      const response = await api.get(
        `v1/backoffice/distributor-users/${distributorUserId}`,
      );

      if (response.status === 200) {
        dispatch(acGetDistributorUser({ ...response.data }));
      }
    } catch (error) {
      return toast.error(ToastMessages.general.error.genericError);
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
